module.exports = __webpack_public_path__ + "static/media/umrah-solution-overview.ebe4af74.png";